import { invokeBackendRoute } from '@/backend/invoke';
import type { GetAllEmployeesWithAuthInfo } from '@cloudFunctions/types/getAllEmployeesWithAuthInfo';
import type { SendEmployeeInvite } from '@cloudFunctions/types/firms/sendEmployeeInvite';
import type { SendEmployeePasswordResetLink } from '@cloudFunctions/types/firms/sendEmployeePasswordResetLink';
import type { UpdateEmployee } from '@cloudFunctions/types/firms/updateEmployee';
import type { EmployeeRegistrationPageData } from '@shared/types';

export interface GetEmployeeRegistrationPageProps {
  registrationPageId: string;
}

export type GetEmployeeRegistrationPageResult =
  | {
      status: 'success';
      payload: EmployeeRegistrationPageData;
    }
  | {
      status: 'error';
      error: string;
    };

export type {
  GetAllEmployeesWithAuthInfo,
  SendEmployeeInvite,
  SendEmployeePasswordResetLink,
};

export const getAllEmployeesWithAuthInfo =
  async (): Promise<GetAllEmployeesWithAuthInfo.Result> =>
    invokeBackendRoute<GetAllEmployeesWithAuthInfo.Result>(
      'getAllEmployeesWithAuthInfo',
    );

export const sendEmployeeInvite = async (
  props: SendEmployeeInvite.Props,
): Promise<SendEmployeeInvite.Result> =>
  invokeBackendRoute<SendEmployeeInvite.Result, SendEmployeeInvite.Props>(
    'sendEmployeeInvite',
    props,
  );

export const getEmployeeRegistrationPage = async (
  props: GetEmployeeRegistrationPageProps,
): Promise<GetEmployeeRegistrationPageResult> =>
  invokeBackendRoute<
    GetEmployeeRegistrationPageResult,
    GetEmployeeRegistrationPageProps
  >('getEmployeeRegistrationPage', props);

export const findEmployeeTenant = async (email: string) => {
  const result = await invokeBackendRoute<
    { tenantId: string },
    { email: string }
  >('findEmployeeTenant', { email });

  return result.tenantId;
};

export const sendEmployeePasswordResetLink = async (
  props: SendEmployeePasswordResetLink.Props,
): Promise<SendEmployeePasswordResetLink.Result> =>
  invokeBackendRoute<
    SendEmployeePasswordResetLink.Result,
    SendEmployeePasswordResetLink.Props
  >('sendEmployeePasswordResetLink', props);

export const updateEmployee = async (
  props: UpdateEmployee.Props,
): Promise<UpdateEmployee.Result> =>
  invokeBackendRoute<UpdateEmployee.Result, UpdateEmployee.Props>(
    'updateEmployee',
    props,
  );
